import { apiInternetBase, closeLoading, HttpType, MIME_TYPE, openLoading } from 'gf-ui';

export class apiQuestionario extends apiInternetBase {
  constructor(root, dispatch, apiCallback, token) {
    super(dispatch, apiCallback, token, root)
  }

  #contattaStruttura = (cb) => this._getJson(HttpType.POST, `/contatta-struttura`, cb, this.token);
  #elencoCategorie = (cb) => this._getJson(HttpType.POST, '/categorie/elenco-categorie', cb, this.token);
  #elencoSubcategorie = (cb) => this._getJson(HttpType.POST, `/categorie/elenco-subcategorie`, cb, this.token);
  #elencoModelli = (cb) => this._getJson(HttpType.POST, `/categorie/elenco-modelli`, cb, this.token);
  #init = (cb) => this._getJson(HttpType.POST, `/init`, cb, this.token);
  #getDisponibilita = (cb) => this._getJson(HttpType.POST, `/scheda/disponibilita`, cb, this.token);
  #schedaNuova = (cb) => this._getJson(HttpType.POST, '/scheda/nuova', cb, this.token);
  #salvaRisposte = (cb) => this._getJson(HttpType.POST, '/scheda/salva', cb, this.token);
  #termina = (cb) => this._getJson(HttpType.POST, `/scheda/termina`, cb, this.token);

  // FILE
  #stampa = (cb, filename) =>
    this._downloadFileStream(
      HttpType.POST,
      `/scheda/stampa`,
      cb,
      this.token,
      MIME_TYPE.PDF, // Passa l'intero oggetto MIME_TYPE.PDF
      filename       // Passa il nome file qui!
    );
  // #stampa                 = (cb) => this._downloadFileResponse(HttpType.POST, `/scheda/stampa`, cb, this.token);  

  fnInit = (fnReturn, params, fnError) => {
    openLoading(this.dispatch)
    this.setParams(params);
    this.#init((status, res) => this.apiCallback(status, res, fnReturn, fnError, "/logout"))
  }

  fnSchedaNuova = (fnReturn, params, fnReturnError) => {
    openLoading(this.dispatch);
    this.setParams(params);
    this.#schedaNuova((status, res) => this.apiCallback(status, res, fnReturn, fnReturnError))
  }

  fnSalvaRisposte = (fnReturn, params, fnReturnError) => {
    openLoading(this.dispatch);
    this.setParams(params);
    this.#salvaRisposte((status, res) => this.apiCallback(status, res, fnReturn, fnReturnError))
  }

  fnGetDisponibilita = (fnReturn, params, fnReturnError) => {
    openLoading(this.dispatch);
    this.setParams(params);
    this.#getDisponibilita((status, res) => this.apiCallback(status, res, fnReturn, fnReturnError))
  }

  fnTermina = (fnReturn, params, fnReturnError) => {
    openLoading(this.dispatch);
    this.setParams(params);
    this.#termina((status, res) => this.apiCallback(status, res, fnReturn, fnReturnError))
  }

  fnStampa = (fnReturn, params, filename, fnReturnError) => {
    openLoading(this.dispatch);
    this.setParams(params);
    this.#stampa((status, errorMsg) => {
      closeLoading(this.dispatch);
      if (status) {
        fnReturn(status);
      } else {
        fnReturnError(status, errorMsg);
      }
    }, filename); // Passiamo il nome file
  }

  fnContattaStruttura = (fnReturn, params, fnReturnError) => {
    openLoading(this.dispatch);
    this.setParams(params);
    this.#contattaStruttura((status, res) => this.apiCallback(status, res, fnReturn, fnReturnError))
  }

  fnElencoCategorie = (fnReturn, params, fnReturnError) => {
    openLoading(this.dispatch);
    this.setParams(params);
    this.#elencoCategorie((status, res) => this.apiCallback(status, res, fnReturn, fnReturnError))
  }

  fnElencoSubcategorie = (fnReturn, params, fnReturnError) => {
    openLoading(this.dispatch);
    this.setParams(params);
    this.#elencoSubcategorie((status, res) => this.apiCallback(status, res, fnReturn, fnReturnError))
  }

  fnElencoModelli = (fnReturn, params, fnReturnError) => {
    openLoading(this.dispatch);
    this.setParams(params);
    this.#elencoModelli((status, res) => this.apiCallback(status, res, fnReturn, fnReturnError))
  }

}